/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import { Helmet } from "react-helmet"

import CookiesSE from "../../components/Cookies/CookiesSE"

export default function CookiesPageSV() {
  return (
    <>
      <Helmet>
        <title>Cookies - Brocc</title>
        <meta
          name="description"
          content="Information om cookies och hur vi använder dem på Brocc."
        />
      </Helmet>
      <CookiesSE />
    </>
  )
}
